// Imports
import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../shareables/foundation/front-end/redux/hooks';
import apiActions from '../../../../shareables/integrations/api/redux/actions';
import { GetSelfResponse } from '../../../../shareables/types/api/main/self/get';
import useMemberCheck from '../../../../utils/use-member-check';


// Function component
const RequireAuthentication: React.FC = () => {
	// Use Redux functionality
	const signedIn = useAppSelector((state) => state.common.user.signedIn);
	const member = useAppSelector((state) => state.self.member);
	const memberLoaded = useAppSelector((state) => state.self.memberLoaded);
	const globalSignInLoaded = useAppSelector((state) => state.self.globalSignInLoaded);
	const isMember = useMemberCheck({ type: 'MEMBER' });
	const dispatch = useAppDispatch();
	
	
	// Redirect user to SSO if not signed in
	//  -> This works because we don't set disableRedirectToSignIn on the API call
	useEffect(() => {
		if (!signedIn) {
			void dispatch(
				apiActions.call<undefined, undefined, GetSelfResponse>({
					action: 'GET',
					uri: '/self',
					cancelOnRouteChange: false,
					completion: () => {
						// Do nothing
					},
				})
			);
		}
	}, [dispatch, signedIn]);
	
	
	// If not signed in, then display nothing
	if (!signedIn) {
		return null;
	}
	
	
	// If loading, then display nothing
	if (!memberLoaded || (!member && !globalSignInLoaded)) {
		return null;
	}
	
	
	// Redirect non-members without special access to the homepage
	if (!isMember) {
		return <Navigate to='/' replace />;
	}
	
	
	// Return JSX
	return <Outlet />;
};

export default RequireAuthentication;
